import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  CreateExternalCandidacyCommentRequest,
  ExternalCandidacyComment,
  HttpResponse,
} from "@/types";

export function useCreateAddExternalCandidacyComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      candidacyId,
      createExternalCandidacyCommentRequest,
    }: {
      candidacyId: string;
      createExternalCandidacyCommentRequest: CreateExternalCandidacyCommentRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/external-candidacy-comments`;
      const res = await guacHttpClient.post<
        ExternalCandidacyComment,
        HttpResponse<ExternalCandidacyComment>,
        CreateExternalCandidacyCommentRequest
      >(path, createExternalCandidacyCommentRequest);
      return res.data;
    },
    onSuccess: (newComment, variables) => {
      queryClient.setQueryData(
        [
          "external-candidacy-comments",
          currentCompanyId,
          currentJobId,
          variables.candidacyId,
        ],
        (cachedData?: ExternalCandidacyComment[]) => {
          // Important to add the new comment to the top of the list.
          return [newComment, ...(cachedData ?? [])];
        },
      );
    },
  });
}
